module.exports = __webpack_public_path__ + "static/img/cases_banner.2a8c2f8.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/banner/cases_banner.jpg
// module id = V1Yx
// module chunks = 5